import { type FC } from 'react'
import classNames from 'classnames'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { type CustomWorkflowSummary } from '../../store/customWorkflow/customWorkflows'
import styles from './CustomWorkflows.module.scss'

interface WorkflowDetailsProps {
  workflow: Pick<CustomWorkflowSummary, 'description' | 'details'>
  className?: string
}

export const WorkflowDetails: FC<WorkflowDetailsProps> = ({ workflow, className }) => {
  if (workflow.details) {
    return (
      <div className={classNames(styles.richText, className)}>
        <ReactMarkdown remarkPlugins={[remarkGfm]}>{workflow.details}</ReactMarkdown>
      </div>
    )
  }
  return workflow.description ? <div className={className}>{workflow.description}</div> : null
}
